import React from 'react';
import { FeedbackBox } from '@highereducation/hen-ui';
import { parseHtmlString } from '../../shared/utils';
import type { Step } from '../../types/types';

interface StepTooltipProps {
  step: Step;
}

export const StepTooltip: React.FC<StepTooltipProps> = ({ step }) => {
  if (!step.tooltip) return null;

  return <FeedbackBox>{parseHtmlString(step.tooltip)}</FeedbackBox>;
};
